import http from 'axios'

export default {
  getRedirections: () => {
    return http.get(`/web/v1/redirection`)
  },
  getRedirection: (path) => {
    return http.get(`/web/v1/redirection/${path}`)
  },
  createRedirection: (redirection) => {
    return http.post(`/web/v1/redirection`, redirection)
  },
  updateRedirection: (redirection) => {
    return http.put(`/web/v1/redirection/${redirection.id}`, redirection)
  },
  deleteRedirection: (id) => {
    return http.delete(`/web/v1/redirection/${id}`)
  },
  getPagesOrigines: () => {
    return http.get(`/web/v1/redirection/page-web`)
  },
  getPictogrammes: () => {
    return http.get(`/web/v1/redirection/pictogramme`)
  },
  createRedirectionUtilisation: (username, redirectionUtilisation) => {
    return http.post(`/web/v1/user/${username}/redirection/utilisation`, redirectionUtilisation)
  },
}
